// extracted by mini-css-extract-plugin
module.exports = {"dark":"pro-badge_dark__t1_uA"};